/**
 * AH – Press Bar  |  Nasalix Shopify Theme
 * File: assets/ah-press-bar.js
 *
 * Static section — no JS behaviour needed in the storefront.
 * This file handles Shopify Theme Editor events only.
 */

(function ($) {
  'use strict';

  /* Theme editor: scroll to section when selected in sidebar */
  document.addEventListener('shopify:section:select', function (e) {
    var el = document.getElementById('ah-press-bar-' + e.detail.sectionId);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  /* Theme editor: scroll to block (individual logo) when selected */
  document.addEventListener('shopify:block:select', function (e) {
    var sectionEl = document.getElementById('ah-press-bar-' + e.detail.sectionId);
    if (!sectionEl) return;
    var blockEl = sectionEl.querySelector('[data-block-id="' + e.detail.blockId + '"]');
    if (blockEl) blockEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

})(jQuery);